import { zip } from "lodash";
import React, { ComponentProps } from "react";

import { useQueryGetBankLabels } from "../../api/operations/bank";

import FacetCheckboxFilter from "./FacetCheckboxFilter";

const FilterBank = (props: ComponentProps<typeof FacetCheckboxFilter>) => {
  const filteredOptions = props.options.filter(
    // @todo this is sad and dumb, but we'll hopefully be incorporating user content soon?
    (b) => !b.value.endsWith("/user-content"),
  );
  const values = filteredOptions.map((o) => o.value);

  const { data: labels } = useQueryGetBankLabels(values);

  const overrides = Object.fromEntries(zip(values, labels));

  return (
    <FacetCheckboxFilter
      {...props}
      options={filteredOptions}
      labelOverrides={overrides}
    />
  );
};

export default FilterBank;
